"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Person = /** @class */ (function () {
    function Person() {
    }
    return Person;
}());
exports.default = Person;
//# sourceMappingURL=Person.js.map